export enum ContractsPageViewType {
  CALENDAR = 'calendar',
  LIST = 'list',
  AVAILABILITY = 'availability',
  ARCHIVE = 'archive',
}
